import { useQuery } from '@tanstack/react-query';
import { botStatusApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * 母艦 bot の最新稼働レポート取得フック。
 *
 * **自動で再取得する。** 開きっぱなしのタブが古い状態を映し続けると、状態を確認するための
 * ページが逆に誤った安心を与える。collector の送信間隔（5 分）より短く引いて、
 * 画面の鮮度が collector の鮮度を下回らないようにする。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business 母艦 bot 稼働状況の取得フック。TanStack Query で定期再取得し画面の鮮度を保つ。
 * @graph-connects botStatusApi [calls] bot-status 最新レポート API クライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useBotStatus(host?: string) {
  return useQuery({
    queryKey: queryKeys.botStatus.latest(host),
    queryFn: () => botStatusApi.getLatest(host),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
